import React, {useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getStoreConfig} from "../../../services/Store/reducer";
import {RootState} from "../../../../reducers";
import {ReactComponent as MenuSVG} from "../../../../images/icons/menu.svg";
import {ReactComponent as BasketSVG} from "../../../../images/icons/basket.svg";
import {ReactComponent as BellRingSVG} from "../../../../images/icons/bell-ring.svg";
import {ReactComponent as ArrowRightSVG} from "../../../../images/icons/arrow-right.svg";
import {Link} from "react-router-dom";
import StoreUtils from "../../../services/Store/StoreUtils";
import {getUser} from "../../../services/User/reducer";
import {api} from "../../../services/Api/api";
import {getSession} from "../../../services/Session/reducer";
import ChangeTableNumberModal from "../../../components/Modal/ChangeTableNumberModal";
import {addFlash} from "../../../services/Notifications/actions";
import handleException from "../../../services/Api/handleException";
import Money from "../../../components/Common/Money";

interface OwnProps {

}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const HomePageMenusComponent = (props: Props) => {
    const [callWaiterLoading, setCallWaiterLoading] = useState(false);
    const [tableNumberModal, setTableNumberModal] = useState(false);
    const [tableOrders, setTableOrders] = useState<any[]>([]);
    const {config} = props;
    let {t} = useTranslation();
    const tableNumber = props.session.table_number;

    const callWaiter = async () => {
        setCallWaiterLoading(true);
        if (tableNumber === undefined) {
            setTableNumberModal(true)
            setCallWaiterLoading(false);
            return;
        }
        try {
            await api.callWaiter(tableNumber);
            props.dispatch(addFlash('success', t("alert.success.call_waiter")));
        } catch (err) {
            let errors = handleException(err);
            props.dispatch(addFlash('error', errors));
        }
        setCallWaiterLoading(false);
    }

    const getTableOrders = async () => {
        if (!props.config?.table.payment) return;
        if (!StoreUtils.isTable(props.session)) return;
        try {
            const response = await api.getTableOrders(tableNumber);
            setTableOrders(response);
        } catch (err) {
            let errors = handleException(err);
            props.dispatch(addFlash('error', errors));
        }
    }
    useEffect(() => {
        getTableOrders();
    }, []);
    if (!config) return null;
    const orderTypes = props.config ? StoreUtils.getOrderTypes(props.config) : [];
    return (
        <>
            <ChangeTableNumberModal tableName={tableNumber} show={tableNumberModal}
                                    onSave={() => setTableNumberModal(false)}
                                    onHide={() => setTableNumberModal(false)}/>
            <div className={"homepage-menus"}>
                <div className={"container-fluid"}>
                    {(StoreUtils.isTable(props.session)) && (
                        <div className={"table"}>
                            {t("common.word.table")}: <strong>{props.session.table_number}</strong>
                        </div>
                    )}
                    <div className="nav flex-column nav-pills w-100 nav-complex">
                        {(props.session.order_type === "DINE_IN" && props.config?.table.payment && tableOrders.length > 0) && (
                            <>
                                {tableOrders.map(tableOrder => {
                                    if (!tableOrder.url) return null;
                                    const tableOrderUrlBase = btoa(unescape(encodeURIComponent(tableOrder.url)));
                                    return (
                                        <Link to={`table_order/${tableOrderUrlBase}`}
                                              className="nav-link nav-link-homepage bg-primary">
                                            <div className={"icon-square"}>
                                                <BasketSVG/>
                                            </div>
                                            <div>
                                                <h1>
                                                    {t("modules.home_page.field.order.title")}
                                                </h1>
                                                <p>
                                                    <Money value={tableOrder.total_amount}/> • #{tableOrder.number}
                                                </p>
                                            </div>
                                            <ArrowRightSVG/>
                                        </Link>
                                    )
                                })}
                            </>
                        )}
                        {(props.session.order_type === "DINE_IN" && props.config?.table.call_waiter) && (
                            <button onClick={callWaiter} className="nav-link nav-link-homepage">
                                <div className={"icon-square"}>
                                    <BellRingSVG/>
                                </div>
                                <div>
                                    <h1 className="home-page-small-heading">
                                        {t("modules.home_page.field.call_waiter.title")}
                                    </h1>
                                    <p>
                                        {t("modules.home_page.field.call_waiter.description")}
                                    </p>
                                </div>
                                {callWaiterLoading ? (
                                    <span className="left spinner-border spinner-border-sm"/>
                                ) : (
                                    <ArrowRightSVG/>
                                )}
                            </button>
                        )}
                        <Link to={"menu"} className="nav-link nav-link-homepage">
                            <div className={"icon-square"}>
                                <MenuSVG/>
                            </div>
                            <div>
                                <h1 className="home-page-small-heading">
                                    {t("modules.home_page.field.menu.title")}
                                </h1>
                                <p>
                                    {orderTypes.map(x => t(`enums.order.type.${x}`)).join(", ")}
                                </p>
                            </div>
                            <ArrowRightSVG/>
                        </Link>
                        {/*{(UserUtils.isLoyaltyRegistration(props.config) && (!props.user || !props.user.name)) && (*/}
                        {/*    <Link to={"menu"} className="nav-link nav-link-homepage">*/}
                        {/*        <div className={"homepage-menu-link-icon"}>*/}
                        {/*            <MenuSVG/>*/}
                        {/*        </div>*/}
                        {/*        <div>*/}
                        {/*            <h1 className="home-page-small-heading">*/}
                        {/*                Założ konto*/}
                        {/*            </h1>*/}
                        {/*            <p>*/}
                        {/*                Załóż konto aby uzyskać 10% zniżki na pierwsze zamówienie!*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*        <ArrowRightSVG/>*/}
                        {/*    </Link>*/}
                        {/*)}*/}
                        {/*{((props.user && props.user.name)) && (*/}
                        {/*    <Link to={"menu"} className="nav-link nav-link-homepage">*/}
                        {/*        <div className={"homepage-menu-link-icon"}>*/}
                        {/*            <MenuSVG/>*/}
                        {/*        </div>*/}
                        {/*        <div>*/}
                        {/*            <h1 className="home-page-small-heading">*/}
                        {/*                Twoje konto*/}
                        {/*            </h1>*/}
                        {/*            <p>*/}
                        {/*                Kliknij żeby zobaczyć swoje nagrody lub zeskanować qrcode*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*        <ArrowRightSVG/>*/}
                        {/*    </Link>*/}
                        {/*)}*/}
                    </div>

                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    user: getUser(state.user),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(HomePageMenusComponent));